import {
  getDedicatedReportRouteName,
  isDedicatedReportGroupBy,
} from '@/views/reports/report-route-behavior';

export const resolveAllowedMetricsForDimension = <T>(
  dimension: string,
  options: {
    getDedicatedColumns: (routeName: string) => T[];
    getSimpleColumns: (dimension: string) => T[];
  },
) => {
  if (isDedicatedReportGroupBy(dimension)) {
    return options.getDedicatedColumns(getDedicatedReportRouteName(dimension));
  }

  return options.getSimpleColumns(dimension);
};

export const runReportRouteChanged = (options: {
  update: () => void;
  resetTree?: () => void;
  setTableNextReportGroup: (value: unknown) => void;
  setTableSelectedItems: (items: unknown[] | null) => void;
}) => {
  options.update();

  options.setTableNextReportGroup(null);
  options.setTableSelectedItems(null);

  options.resetTree?.();
};
